import { render } from "./IpTracker.vue?vue&type=template&id=5e6360ec"
import script from "./IpTracker.vue?vue&type=script&lang=ts"
export * from "./IpTracker.vue?vue&type=script&lang=ts"
script.render = render

export default script